module.exports = __webpack_public_path__ + "img/product-ketang-jbg-02.fc98fe98.png";